<div class="place-map-section">
    <agm-map [styles]="hideIconMapStyler" [latitude]="place?.lat"
             [longitude]="place?.lng" [zoom]="mapZoom" (mapClick)="getDirection()">
        <agm-marker *ngIf="place?.lat&&place?.lng" [latitude]="place?.lat" [longitude]="place?.lng">
        </agm-marker>
    </agm-map>

    <div group class="m-t-1">
        <ig-button size="md"
                   (trigger)="visitWebsite()">{{isAccommodation ? 'Book Now' : 'More Information'}}</ig-button>
        <ig-button size="md" class="deep-orange-btn m-t-1" (trigger)="getDirection()">Get Directions
        </ig-button>
        <ig-add-to-trip-menu *ngIf="featuresToggle.tripPlanner" [hubName]="hubName"
                             [item]="place"></ig-add-to-trip-menu>
    </div>
</div>


// WEBPACK FOOTER //
// D:/Work/Development/ImGoing/IMGoing/web/src/components/visitor/place.details.modal/place.map.section.component/place.map.section.component.html